const formatKeys = {
    number: 'number',
    percent: 'percent',
    currency: 'currency',
    date: 'date',
    quarter: 'quarter',
    boolean: 'boolean',
    array: 'array',
    string: 'string',
    ids: 'ids'
};

const metrics = {
    GroupBy: {
        titleKey: 'day',
        isSortable: true,
        Day: {
            format: formatKeys.date,
            title: 'Day'
        },
        Offer: {
            format: formatKeys.ids,
            title: 'Offer'
        },
        UnactivePeriod: {
            format: formatKeys.ids,
            title: 'UnactivePeriod'
        },
        Param2: {
            format: formatKeys.ids,
            title: 'Param2'
        },
        UtmMedium: {
            format: formatKeys.ids,
            title: 'UtmMedium'
        },
        UtmSource: {
            format: formatKeys.ids,
            title: 'UtmSource'
        },
        UtmCampaign: {
            format: formatKeys.ids,
            title: 'UtmCampaign'
        },
        UtmTerm: {
            format: formatKeys.ids,
            title: 'UtmTerm'
        },
        UtmContent: {
            format: formatKeys.ids,
            title: 'UtmContent'
        }
    },
    UnactivePeriod: {
        format: formatKeys.array,
        titleKey: 'UnactivePeriod',
        visible: true,
        isSortable: true
    },
    ReactivationCount: {
        format: formatKeys.number,
        titleKey: 'ReactivationCount',
        visible: true,
        isSortable: true
    },
    SaleSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'saleSum',
        visible: true,
        isSortable: true
    },
    DynamicCprAmount: {
        format: formatKeys.currency,
        titleKey: 'DynamicCprAmount',
        visible: true,
        isSortable: true
    }
};

const treeMetric = [
    [
        {
            config: {
                key: 'groups',
                metrics: ['GroupBy']
            }
        },
        {
            config: {
                key: 'measurements',
                metrics: ['UnactivePeriod', 'ReactivationCount', 'SaleSumConfirmed', 'DynamicCprAmount']
            }
        }
    ]
];

export {
    formatKeys,
    metrics,
    treeMetric
};
